import { render, staticRenderFns } from "./CreateMyBusiness.vue?vue&type=template&id=5d4a80a4&"
import script from "./CreateMyBusiness.vue?vue&type=script&lang=js&"
export * from "./CreateMyBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports